import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from './LandingPage';
import AboutUs from './pages/AboutUs';
import Blog from './pages/Blog';
import Events from './pages/Events';
import Profile from './pages/Profile';
import HeaderBlock from './components/HeaderBlock';

function App() {
  return (
    <Router>
      <div className="App">
        <HeaderBlock />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/events" element={<Events />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;